import api from "src/services/core/api";
import { ApiRequest } from "src/models/api.request";
import VwIstemPanelTanimDTO from "src/models/GenelTanimlar/VwIstemPanelTanimDTO";
import VwHbsIslemtanimDTO from "src/models/GenelTanimlar/VwHbsIslemtanimDTO";

const controllerName = "VwIstemPanelTanimDTO";

export const IstemPanelTanimApi = api.injectEndpoints({
    endpoints: builder => ({
        IstemPanelGrupGetir: builder.query<Array<VwIstemPanelTanimDTO>, boolean>({
            query: (request) => {
                let req: ApiRequest<VwIstemPanelTanimDTO> = {
                    filters: {
                        groupOperator: "and",
                        predicates: [
                            { fieldName: "tip", operator: "<", value1: 4 },

                        ]
                    },
                    paging: false,
                    sorts: [{ fieldName: 'id',ascending: true }]
                }
                if(!request)
                    req.filters.predicates.push(
                        { fieldName: "aktif", operator: "=", value1: "E"  },
                    )
                return {
                    url: controllerName + "/Find",
                    method: "POST",
                    body: JSON.stringify(req)
                }
            },
            providesTags: ['IstemPanelGrup']
        }),
        IstemPanelIslemGetir: builder.query<Array<VwIstemPanelTanimDTO>, {fkId: number}>({
            query: (request) => {
                let req: ApiRequest<VwIstemPanelTanimDTO> = {
                    filters: {
                        groupOperator: "and",
                        predicates: [
                            { fieldName: "tip", operator: "=", value1: 4 },
                            { fieldName: "fkIstempaneltanimId", operator: "=", value1: request.fkId },
                        ]
                    },
                    paging: false,
                    sorts: [{ fieldName: 'id', ascending: false }]
                }
                return {
                    url: controllerName + "/Find",
                    method: "POST",
                    body: JSON.stringify(req)
                }
            },
            providesTags: ['IstemPanelIslem']
        }),
        IstemPanelGrupEkle: builder.mutation<VwIstemPanelTanimDTO, VwIstemPanelTanimDTO>({
            query: (request) => ({
                url: controllerName,
                method: "POST",
                body: JSON.stringify(request)
            }),
        }),
        IstemPanelGrupGuncelle: builder.mutation<VwIstemPanelTanimDTO, VwIstemPanelTanimDTO>({
            query: (request) => ({
                url: controllerName,
                method: "PUT",
                body: JSON.stringify(request)
            }),
        }),
        IstemPanelGrupSil: builder.mutation<boolean, VwIstemPanelTanimDTO>({
            query: (request) => ({
                url: controllerName,
                method: "PUT",
                body: JSON.stringify(request)
            }),
        }),
        IslemTanimGetir: builder.query<Array<VwHbsIslemtanimDTO>, void>({
            query: (request) => {
                let req: ApiRequest<VwHbsIslemtanimDTO> = {
                    filters: {
                        groupOperator: "and",
                        predicates: [
                            { fieldName: "aktif", operator: "=", value1: "E" },
                            // { fieldName: "islemtanimtipId", operator: "=", value1: 1 },
                        ]
                    },
                    paging: false,
                    sorts: [{ fieldName: 'id',ascending: true }]
                }
                return {
                    url: "VwHbsIslemtanimDTO/Find",
                    method: "POST",
                    body: JSON.stringify(req)
                }
            },
            // providesTags: ['Islemtanim']
        }),
        IstemPanelEkle: builder.mutation<VwIstemPanelTanimDTO, VwIstemPanelTanimDTO>({
            query: (request) => ({
                url: controllerName,
                method: "POST",
                body: JSON.stringify(request)
            }),
        }),
        IstemPanelSil: builder.mutation<boolean, VwIstemPanelTanimDTO>({
            query: (request) => ({
                url: controllerName + "/" + request.id,
                method: "DELETE"
            }),
        }),
    })
})

export const {
    useIstemPanelGrupGetirQuery,
    useLazyIstemPanelIslemGetirQuery,
    useLazyIstemPanelGrupGetirQuery,
    useIstemPanelIslemGetirQuery,
    useIstemPanelGrupEkleMutation,
    useIstemPanelGrupGuncelleMutation,
    useIstemPanelGrupSilMutation,
    useIslemTanimGetirQuery,
    useIstemPanelEkleMutation,
    useIstemPanelSilMutation
} = IstemPanelTanimApi;